var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrp5FrontPointer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "c9bfdf45-8e57-4245-9099-de73a7ca496f",
    "data-name": "Marker",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.2 840.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".crp5_79{fill:url(#9c9c2c53-c4f9-47be-a01b-78589dcf0a10)}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "9c9c2c53-c4f9-47be-a01b-78589dcf0a10",
    cx: 2.65,
    cy: 839.27,
    r: 0.78,
    gradientTransform: "matrix(7.12, 4.23, 4.23, -7.12, -3274.51, 6386.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323232"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "crp5_79",
    d: "M302.09 423.22l.67.4a6 6 0 0 1-8.26 2.1l.42-.66-.4.67a6 6 0 0 1-2.1-8.26l.64.42-.66-.39a6 6 0 0 1 8.26-2.11l-.35.59.32-.61-.35.59.32-.61a6 6 0 0 1 2.1 8.27l-.63-.38.66.33v.05l-.63-.38.66.33-.67-.4-.69-.34v-.05a4.5 4.5 0 0 0-1.57-6.15l.4-.66-.36.68a4.48 4.48 0 0 0-6.14 1.57l-.59-.39.61.36-.59-.39.61.36a4.49 4.49 0 0 0 1.56 6.14l-.33.7.33-.56-.33.56.33-.56a4.49 4.49 0 0 0 6.14-1.56l.66.39-.69-.34z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M297.6 229.3c-16.11 0-37 3.79-37 3.79v184.67c.92 22.11 17.11 39.72 37 39.72s36-17.61 36.95-39.72h.05V233.09s-20.89-3.79-37-3.79z",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#840000",
    fill: "none",
    strokeMiterlimit: 10,
    d: "M297.63 372.67V229.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M297.6 229.3c-16.11 0-37 3.79-37 3.79v184.67c.92 22.11 17.11 39.72 37 39.72s36-17.61 36.95-39.72h.05V233.09s-20.89-3.79-37-3.79z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "none",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrp5FrontPointer);
export default __webpack_public_path__ + "static/media/crp5-front-pointer.fccbb83eaeca24e63571a0bb06aa1bf1.svg";
export { ForwardRef as ReactComponent };